import React from "react";
import { Breadcrumb } from "antd";
import { HomeOutlined } from '@ant-design/icons';
import { useHistory } from "react-router-dom";

const ModuleBreadcrumb = ({ title, breadcrumbs, links }) => {
  const history = useHistory();
  return (
    <div className="gx-profile-banner">
      <div className="gx-profile-container">
        <div className="gx-profile-banner-top">
          <div className="gx-profile-banner-top-left">
            <div className="gx-profile-banner-avatar-info">
              <h2 className="gx-mb-2 gx-mb-sm-3 gx-fs-xxl gx-font-weight-light">{title}</h2>
              <Breadcrumb>
                <Breadcrumb.Item onClick={() => {
                  if(links && links.length && links[0] !== "") {
                    history.push(links[0])
                  }
                }}>
                  <span className="gx-link">
                    <HomeOutlined />
                  </span>
                </Breadcrumb.Item>
                {
                  breadcrumbs && 
                  breadcrumbs.map((b,i) => {
                    return (
                      <Breadcrumb.Item
                        key={i}
                        onClick={() => {
                          if(links && links.length && links[i+1] !== "") {
                            history.push(links[i+1])
                          }
                        }}
                      >
                        <span className="gx-link">{b}</span>
                      </Breadcrumb.Item>
                    )
                  })
                }
              </Breadcrumb>
            </div>
          </div>
          {/* <div className="gx-profile-banner-top-right">
            <ul className="gx-follower-list">
              <li>
                <span className="gx-follower-title gx-fs-lg gx-font-weight-medium">2k</span>
                <span className="gx-fs-sm">Total</span></li>
              <li>
                <span className="gx-follower-title gx-fs-lg gx-font-weight-medium">1.5k</span>
                <span className="gx-fs-sm">Active</span></li>
              <li>
                <span className="gx-follower-title gx-fs-lg gx-font-weight-medium">500</span>
                <span className="gx-fs-sm">Inactive</span>
              </li>
            </ul>
          </div> */}
        </div>
      </div>
    </div>
  )
};

export default ModuleBreadcrumb;
